






































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  DocuSignTemplateAdditionalDocumentConfigurationModel,
  DocuSignTemplateAdditionalDocumentCreateUpdateModel,
  DocuSignTemplateAdditionalDocumentSignHereModel,
  DocuSignAdditionalDocumentFileModel,
  DocuSignAdditionalDocumentSignTabModel,
  DocuSignTemplateAdditionalDocumentSignHereCreateUpdateModel,
  Dictionary,
  Configuration
} from '@/types';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
export default Vue.extend({
  name: 'DocuSignUpdateTemplateAdditionalDocument',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    submitIsLoading: {
      type: Boolean,
      required: true
    },
    templateAdditionalDocumentConfiguration: {
      type: Object as () => DocuSignTemplateAdditionalDocumentConfigurationModel,
      required: true,
      default: {} as DocuSignTemplateAdditionalDocumentConfigurationModel
    },
    templateAdditionalDocument: {
      type: Object as () => DocuSignTemplateAdditionalDocumentCreateUpdateModel,
      required: true,
      default: {} as DocuSignTemplateAdditionalDocumentCreateUpdateModel
    },
    serverValidationMessage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hasError: false,
      errorMessage: '',
      pageNumber: '',
      tabSigners: [],
      additionalDocumentFileId: null,
      additionalDocumentSignTabs: {} as DocuSignAdditionalDocumentSignTabModel[],
      loaded: false
    };
  },
  methods: {
    initialise(this: any) {
      this.templateAdditionalDocumentModel = this.templateAdditionalDocumentConfiguration.templateAdditionalDocument;
      this.additionalDocumentFileId = this.templateAdditionalDocumentConfiguration.additionalDocumentFileId;
      this.$nextTick(() => {
        this.resetField('additionalDocumentFile');
      });
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (!isValid || !this.validateSigners()) {
          return;
        }

        this.$emit('submit', {
          documentTypeId: this.documentTypeId,
          templateId: this.templateId,
          additionalDocumentFileId: this.additionalDocumentFileId,
          templateAdditionalDocumentSignHeres: this.getTemplateAdditionalDocumentSignHeres()
        });
      } catch (error) {
        this.$log('Error updating Template Additional Document', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    validateSigners(this: any): boolean {
      if (this.tabSigners.some((x: number) => x === 0)) {
        this.addFormValidationError('Please select a signer for each location');
        return false;
      }
      return true;
    },
    async onCancel(this: any) {
      this.navigateToTemplateAdditionalDocumentManagement();
    },
    navigateToTemplateAdditionalDocumentManagement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateAdditionalDocument.Management.name,
        params: param
      });
    },
    getTemplateAdditionalDocumentSignHeres(this: any): DocuSignTemplateAdditionalDocumentSignHereCreateUpdateModel[] {
      const templateSignHeres: DocuSignTemplateAdditionalDocumentSignHereCreateUpdateModel[] = [];
      this.tabSigners.forEach((value: number, index: number) => {
        templateSignHeres.push({
          additionalDocumentSignTabId: index,
          signerRoleId: value
        } as DocuSignTemplateAdditionalDocumentSignHereCreateUpdateModel);
      });
      return templateSignHeres;
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    templateAdditionalDocumentId(): number {
      return Number(this.$route.params.id);
    },
    selectedAdditionalDocumentHasSignTabs(this: any) {
      return this.additionalDocumentSignTabs.length > 0;
    }
  },
  watch: {
    serverValidationMessage(this: any, value: string) {
      if (!this.isNullOrEmpty(value)) {
        this.addFormValidationError(value);
      }
    },
    additionalDocumentFileId(this: any, value: number | null) {
      if (value === null) {
        return;
      }
      this.tabSigners = [];
      const additionalDocumentFile = this.templateAdditionalDocumentConfiguration.additionalDocumentFiles.find(
        (x: DocuSignAdditionalDocumentFileModel) => x.id === value
      );
      if (!additionalDocumentFile) {
        return;
      }
      this.additionalDocumentSignTabs = additionalDocumentFile.signTabs;
      if (!this.loaded && this.templateAdditionalDocument?.additionalDocumentFile?.id === value) {
        this.templateAdditionalDocument.signHeres.forEach((x: DocuSignTemplateAdditionalDocumentSignHereModel) => {
          this.tabSigners[x.additionalDocumentSignTab.id] = x.signerRole.id;
        });
        this.loaded = true;
        return;
      }
      additionalDocumentFile.signTabs.forEach((x: DocuSignAdditionalDocumentSignTabModel) => {
        this.tabSigners[x.id] = 0;
      });
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  components: {
    MStoreFormSelect
  }
});
